import { render, staticRenderFns } from "./LegacyProjectUserPledge.vue?vue&type=template&id=0a6da95a"
import script from "./LegacyProjectUserPledge.vue?vue&type=script&lang=js"
export * from "./LegacyProjectUserPledge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports